import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import theme from 'src/styles/components/Orders.module.scss';

import Carousel from 'src/components/Carousel';
import OrderItem from 'src/components/Orders/OrderItem';

const Orders = ({
    className,
    areItemsFetched,
    noItemsTranslationKey,
    items,
    createLink,
    onClick,
    summary
}) => {
    const intl = useIntl();

    return (
        <div className={classnames(className, theme.container, theme.overflow)}>
            <div className={theme.contentContainer}>
                <div className={theme.content}>
                    <Carousel
                      elementWidth={360}
                      isInitialized={areItemsFetched}
                      noItemsTranslationKey={noItemsTranslationKey}
                      shouldShowIndicatorDot
                      areIndicatorsEnabled
                      isInfinite={false}
                    >
                        {items.map((item, index) => (
                            <OrderItem
                              key={item.id}
                              item={item}
                              createLink={createLink}
                              onClick={onClick}
                              orderNumber={items.length - index}
                            />
                        ))}
                    </Carousel>
                </div>
            </div>
            <div className={theme.summary}>
                <div className={theme.positions}>
                    {intl.formatMessage({ id: 'App.positionsTemplate' }, { positions: summary.positions })}
                </div>
                <div className={theme.price}>
                    {intl.formatNumber(summary.price, { style: 'currency', currency: 'PLN' })}
                </div>
            </div>
        </div>
    );
};

Orders.propTypes = {
    areItemsFetched: PropTypes.bool.isRequired,
    noItemsTranslationKey: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.object),
    createLink: PropTypes.func,
    onClick: PropTypes.func,
    className: PropTypes.string,
    summary: PropTypes.shape({
        positions: PropTypes.number,
        price: PropTypes.number
    }),
    context: PropTypes.shape({
        tableId: PropTypes.string.isRequired,
        restaurantId: PropTypes.string.isRequired
    })
};

Orders.defaultProps = {
    noItemsTranslationKey: 'App.noItems'
};

export default Orders;
